<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Production Quality Inspection Dimension" active>

                                <b-row v-if="hasFailedDataProductionQualityInspectionDimension">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedProductionQualityInspectionDimension.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionQualityInspectionDimensionsFailed" :fields="fieldsProductionQualityInspectionDimension" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionQualityInspectionDimension" :sort-desc.sync="sortDescProductionQualityInspectionDimension" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(productionDate)="row">
													{{ row.item.productionDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedProductionQualityInspectionDimension.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionQualityInspectionDimensions" :fields="fieldsProductionQualityInspectionDimension" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionQualityInspectionDimension" :sort-desc.sync="sortDescProductionQualityInspectionDimension" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(productionDate)="row">
													{{ row.item.productionDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Production Quality Inspection Dimension Detail" active>

                                <b-row v-if="hasFailedDataProductionQualityInspectionDimensionDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedProductionQualityInspectionDimensionDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionQualityInspectionDimensionDetailsFailed" :fields="fieldsProductionQualityInspectionDimensionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionQualityInspectionDimensionDetail" :sort-desc.sync="sortDescProductionQualityInspectionDimensionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedProductionQualityInspectionDimensionDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionQualityInspectionDimensionDetails" :fields="fieldsProductionQualityInspectionDimensionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionQualityInspectionDimensionDetail" :sort-desc.sync="sortDescProductionQualityInspectionDimensionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import ProductionQualityInspectionDimension from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimension';
import ProductionQualityInspectionDimensionList from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionList';
import ProductionQualityInspectionDimensionFilter from '@/filters/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsProductionQualityInspectionDimension: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process", key: 'workOrderProcessWorkOrderProcessNumber', sortable: false},
				{"class" : "th-status", "label" : "Production Date", key: 'productionDate', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsProductionQualityInspectionDimensionDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Is Checked", key: 'isChecked', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			productionQualityInspectionDimensions : [],
			productionQualityInspectionDimensionsFailed: [],
			productionQualityInspectionDimensionId : '',
			sortByProductionQualityInspectionDimension: '',
			sortDescProductionQualityInspectionDimension: '',
			hasFailedDataProductionQualityInspectionDimension: false,
			totalFailedProductionQualityInspectionDimension: 0,
			totalSucceedProductionQualityInspectionDimension: 0,
			productionQualityInspectionDimensionDetails : [],
			productionQualityInspectionDimensionDetailsFailed: [],
			productionQualityInspectionDimensionDetailId : '',
			sortByProductionQualityInspectionDimensionDetail: '',
			sortDescProductionQualityInspectionDimensionDetail: '',
			hasFailedDataProductionQualityInspectionDimensionDetail: false,
			totalFailedProductionQualityInspectionDimensionDetail: 0,
			totalSucceedProductionQualityInspectionDimensionDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('productionqualityinspectiondimension/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('productionqualityinspectiondimension/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getProductionQualityInspectionDimensionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getProductionQualityInspectionDimensionForUpload : async function() {
			let _this = this;
			this.$http.get('productionqualityinspectiondimension/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.productionQualityInspectionDimensions = [];
_this.productionQualityInspectionDimensionDetails = [];


					if (response != null) {
						let result = response.data;
						_this.productionQualityInspectionDimensions = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedProductionQualityInspectionDimension = _this.productionQualityInspectionDimensions.length;

						_this.productionQualityInspectionDimensionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataProductionQualityInspectionDimension = true;
						_this.totalFailedProductionQualityInspectionDimension = 0;
						if(_this.productionQualityInspectionDimensionsFailed == undefined || _this.productionQualityInspectionDimensionsFailed.length === 0) _this.hasFailedDataProductionQualityInspectionDimension = false;
						if(_this.hasFailedDataProductionQualityInspectionDimension) _this.totalFailedProductionQualityInspectionDimension = _this.productionQualityInspectionDimensionsFailed.length;
						_this.productionQualityInspectionDimensionDetails = [];
						_this.productionQualityInspectionDimensionDetailsFailed = [];
						_this.hasFailedDataProductionQualityInspectionDimensionDetail = true;
						_this.totalSucceedProductionQualityInspectionDimensionDetail = 0;
						result.forEach(function(element) {
							_this.productionQualityInspectionDimensionDetails.push(...element.productionQualityInspectionDimensionDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedProductionQualityInspectionDimensionDetail = _this.productionQualityInspectionDimensionDetails.length;

							_this.productionQualityInspectionDimensionDetailsFailed.push(...element.productionQualityInspectionDimensionDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.productionQualityInspectionDimensionDetailsFailed == undefined || _this.productionQualityInspectionDimensionDetailsFailed.length === 0) _this.hasFailedDataProductionQualityInspectionDimensionDetail = false;
							if(_this.hasFailedDataProductionQualityInspectionDimensionDetail) _this.totalFailedProductionQualityInspectionDimensionDetail = _this.productionQualityInspectionDimensionDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'productionqualityinspectiondimension/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'ProductionQualityInspectionDimension.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterProductionQualityInspectionDimension = new ProductionQualityInspectionDimensionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
